import * as React from "react";
import { ModalContainer, HeaderContainer, CloseButton, FooterWrapper } from "./modal-style";
import { X } from "common/react-plucked";
import { AcceptButton } from "../modal-provider/modal-provider-style";
import { withDefault } from "collection-utils";
import { SimpleModalContextProps } from "designer/modals-v2/modal-provider-v2/modal-context";
import { withModalProvider } from "designer/modals-v2/modal-provider-v2/modal-provider-v2";

interface Props {
    title: React.ReactNode;
    showClose?: boolean;

    width?: number;
    height?: number | "auto";

    canAccept?: boolean;
    acceptText?: string;
    onAccept?: () => void;
    onClose?: () => void;

    animate?: boolean;
    modals: SimpleModalContextProps;
}

class ModalImpl extends React.PureComponent<React.PropsWithChildren<Props>> {
    private onClose = () => {
        if (this.props.onClose !== undefined) {
            this.props.onClose();
        }
        this.props.modals.DEPRECATED_removeAllModals();
    };

    public render(): React.ReactNode {
        const { acceptText, onAccept, canAccept, title, showClose, height, width, animate } = this.props;
        let footer: React.ReactNode;
        if (acceptText !== undefined) {
            footer = (
                <FooterWrapper>
                    <AcceptButton onClick={onAccept} isEnabled={canAccept}>
                        {acceptText}
                    </AcceptButton>
                </FooterWrapper>
            );
        }
        return (
            <ModalContainer width={width} height={height} isFinished={!canAccept || animate === false}>
                {withDefault(showClose, true) && (
                    <CloseButton onClick={this.onClose}>
                        <X size={14} />
                    </CloseButton>
                )}
                <HeaderContainer>{title}</HeaderContainer>
                {this.props.children}
                {footer}
            </ModalContainer>
        );
    }
}

const Modal = withModalProvider(ModalImpl);
export default Modal;
